var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _vm.$vuetify.breakpoint.smAndDown
        ? _c("b", [
            _vm._v("Loaded " + _vm._s(_vm.siteDistanceMeasureUnitsLabel) + ":")
          ])
        : _vm._e(),
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.distanceLabel(_vm.loadModel.loadedMiles(_vm.loadDetails))
          ) +
          "\n  "
      ),
      _vm.loadModel.billOfLadingNumber(_vm.loadDetails)
        ? _c("span", { staticClass: "font-italic" }, [
            _vm._v(
              "\n    (" +
                _vm._s(_vm.$t("terms.bill-of-lading.abbr")) +
                ": " +
                _vm._s(_vm.loadModel.billOfLadingNumber(_vm.loadDetails)) +
                ")\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.showRequirements
        ? [
            _vm.loadModel.requiresWashout(_vm.loadDetails)
              ? _c(
                  "span",
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          width: "25",
                          height: "25",
                          "icon-color": "#352208",
                          "icon-name": "hose"
                        }
                      },
                      [_c("icon-hose")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadModel.requireWoodChips(_vm.loadDetails)
              ? _c(
                  "span",
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          width: "25",
                          height: "25",
                          "icon-color": "#352208",
                          viewBox: "0 0 5 5",
                          "icon-name": "wood"
                        }
                      },
                      [_c("icon-wood")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadModel.requireWeatherboards(_vm.loadDetails)
              ? _c(
                  "span",
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          width: "25",
                          height: "25",
                          "icon-name": "cold",
                          "icon-color": "#352208"
                        }
                      },
                      [_c("icon-cold")],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _c("span", { staticClass: "font-italic" }, [
            _vm._v("\n    based on Google Maps\n  ")
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f74980e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f74980e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/LoadDistance.vue
// module id = null
// module chunks = 